import { ArrowLeft } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgArrowLeft = mkIcon(ArrowLeft);